/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Link from 'react-router/lib/Link';
import CSSModules from 'react-css-modules';
import { MY_PROFILE, PROFILE_STR } from '../../../constants/strings';
import { isLoggedUserSelector } from '../../../redux/context/selectors';
import styles from '../index.styl';

const HiddenLink = ({ href, isLoggedUser, isMobile, isOpened }) => {
  if (!isMobile || isOpened) return null;

  const PROFILE_LINK_TEXT = isLoggedUser ? MY_PROFILE : PROFILE_STR;

  return (
    <div styleName="item">
      <Link activeClassName={styles['link--active']} styleName="link" to={href}>
        <FormattedMessage {...PROFILE_LINK_TEXT} />
      </Link>
    </div>
  );
};

HiddenLink.propTypes = {
  href: PropTypes.string,
  isLoggedUser: PropTypes.bool,
  isMobile: PropTypes.bool,
  isOpened: PropTypes.bool,
};

const mapStateToProps = state => ({
  isLoggedUser: isLoggedUserSelector(state),
});

export default connect(mapStateToProps)(
  CSSModules(HiddenLink, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Header/Components/HiddenLink.jsx